import { createApi } from "@reduxjs/toolkit/query/react";
import { tomService } from "./restService";

/**
 * @Description
 * AI Suggestion & Insights API
 */

export const aiSuggestionApi = createApi({
  reducerPath: "aiSuggestionApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/company`,
  }),

  // Add tag type
  tagTypes: ["AiInsights"],

  endpoints: builder => ({
    /**
     * @Service - AI Insights
     * Provides the AiInsights tag
     */
    fetchAISuggestionMessages: builder.query({
      query: ({ company_id, offer_id }) => ({
        url: `/${company_id}/offer/${offer_id}/insights`,
        method: "GET",
      }),
      providesTags: ["AiInsights"],
    }),

    /**
     * All below services will INVALIDATE insights
     */

    postCompaRatioReview: builder.mutation({
      query: ({ company_id, offer_id, compa_ratio, market_ratio }) => ({
        url: `/${company_id}/offer/${offer_id}/compa-ratio-review/`,
        method: "POST",
        body: { compa_ratio, market_ratio },
      }),
      invalidatesTags: ["AiInsights"],
    }),

    postHireConversionAnalysis: builder.mutation({
      query: ({ company_id, offer_id }) => ({
        url: `/${company_id}/offer/${offer_id}/conversion-analysis/`,
        method: "POST",
      }),
      invalidatesTags: ["AiInsights"],
    }),

    postCriticalPayPositioning: builder.mutation({
      query: ({ company_id, offer_id, compa_ratio, market_ratio }) => ({
        url: `/${company_id}/offer/${offer_id}/critical-pay-positioning/`,
        method: "POST",
        body: { compa_ratio, market_ratio },
      }),
      invalidatesTags: ["AiInsights"],
    }),

    // postPaymentRecommendation: builder.mutation({
    //   query: ({
    //     company_id,
    //     offer_id,
    //     current_total_target_cash,
    //     proposed_total_target_cash,
    //     current_unvested_equity,
    //   }) => ({
    //     url: `/${company_id}/offer/${offer_id}/payment-recommendation/`,
    //     method: "POST",
    //     body: {
    //       current_total_target_cash,
    //       proposed_total_target_cash,
    //       current_unvested_equity,
    //     },
    //   }),
    //   invalidatesTags: ["AiInsights"],
    // }),

    postRetentionRisk: builder.mutation({
      query: ({
        company_id,
        offer_id,
        current_total_target_cash,
        proposed_total_target_cash,
        current_guaranteed_cash,
        proposed_guaranteed_cash,
      }) => ({
        url: `/${company_id}/offer/${offer_id}/retention-risk/`,
        method: "POST",
        body: {
          current_total_target_cash,
          proposed_total_target_cash,
          current_guaranteed_cash,
          proposed_guaranteed_cash,
        },
      }),
      invalidatesTags: ["AiInsights"],
    }),

    // warda apis

    rolesInDemand: builder.mutation({
      query: ({ company_id, offer_id }) => ({
        url: `/${company_id}/offer/${offer_id}/roles_in_demand/`,
        method: "POST",
      }),
      invalidatesTags: ["AiInsights"],
    }),
    oneTimePayment: builder.mutation({
      query: ({
        company_id,
        offer_id,
        current_total_target_cash,
        proposed_total_target_cash,
        current_unvested_equity,
      }) => ({
        url: `/${company_id}/offer/${offer_id}/one_time_payment/`,
        method: "POST",
        body: {
          current_total_target_cash,
          proposed_total_target_cash,
          unvested_equity: current_unvested_equity,
        },
      }),
      invalidatesTags: ["AiInsights"],
    }),
    payTrendBasePay: builder.mutation({
      query: ({ company_id, offer_id, proposed_annual_base_pay }) => ({
        url: `/${company_id}/offer/${offer_id}/base_pay_insights/`,
        method: "POST",
        body: {
          proposed_annual_base_pay,
        },
      }),
      invalidatesTags: ["AiInsights"],
    }),
    payTrendTotalTargetCash: builder.mutation({
      query: ({ company_id, offer_id, total_target_cash }) => ({
        url: `/${company_id}/offer/${offer_id}/ttc_pay_insights/`,
        method: "POST",
        body: {
          total_target_cash,
        },
      }),
      invalidatesTags: ["AiInsights"],
    }),
  }),
});

export const {
  useFetchAISuggestionMessagesQuery,
  usePostCompaRatioReviewMutation,
  usePostHireConversionAnalysisMutation,
  usePostCriticalPayPositioningMutation,
  // usePostPaymentRecommendationMutation,
  usePostRetentionRiskMutation,

  useOneTimePaymentMutation,
  usePayTrendBasePayMutation,
  usePayTrendTotalTargetCashMutation,
  useRolesInDemandMutation,
} = aiSuggestionApi;
